const isBrowser = typeof window !== 'undefined'

let dc
let env
let cell

if (isBrowser) {
  cell =
    (window.PCLN_BOOTSTRAP_DATA &&
      window.PCLN_BOOTSTRAP_DATA.envInfo &&
      window.PCLN_BOOTSTRAP_DATA.envInfo.pclnCell) ||
    ''
  dc =
    (window.PCLN_BOOTSTRAP_DATA &&
      window.PCLN_BOOTSTRAP_DATA.envInfo &&
      window.PCLN_BOOTSTRAP_DATA.envInfo.pclnDC) ||
    ''
} else {
  dc = process.env.BOOTSTRAP_DC || ''
  dc = dc === 'va' ? 'ash1' : dc
  cell = process.env.BOOTSTRAP_ENV || ''
}

cell = cell.replace(/-/, '')

const resolve = function (serviceName, options = {}) {
  const dcOverride = options.dc || false
  const dcToUse = dcOverride || dc

  // dev consul cluster still exists in nw datacenter, not ash1
  const consulDcToUse = env === 'dev' && dcToUse === 'ash1' ? 'nw' : dcToUse

  const cellOverride = options.env || false
  const cellToUse = cellOverride || cell

  if (cellToUse.includes('poc')) {
    env = 'poc'
  } else if (cellToUse.includes('prod') || cellToUse === 'ny' || cellToUse === 'va') {
    env = 'prod'
  } else {
    env = cellToUse.replace(/^(dev|qa).*/, '$1')
  }

  if (isBrowser) {
    if (!dcOverride || !cellOverride) {
      return window.location.host
    } else {
      // https://priceline.atlassian.net/wiki/spaces/Tech/pages/483689165/Fastly+Domains
      if (env === 'dev' || env === 'qa') {
        return `${dcToUse}-${cellToUse}.priceline.com`
      } else if (env === 'prod' && cell === 'preprod') {
        return `${dcToUse}-preprod.priceline.com`
      } else {
        return `${cellToUse}.priceline.com`
      }
    }
  } else {
    const fromEnv = process.env[`SERVICE_${serviceName.toUpperCase()}`]
    if (fromEnv) {
      return fromEnv
    } else {
      const { NODE_ENV, CONSUL_MODE } = process.env

      const consulDataCenter = `${consulDcToUse}-${env}`
      const cellPrefix = env === 'dev' || env === 'qa' || cellToUse === 'preprod' ? `${cellToUse}-` : ''

      const consulDomain =
        options.agentless || CONSUL_MODE === 'agentless' || NODE_ENV === 'development'
          ? `.service.${consulDataCenter}.consul`
          : '.service.consul'
      const upstream = 'lb'
      return `${cellPrefix}${serviceName}-${upstream}${consulDomain}`
    }
  }
}

module.exports = resolve
